import { makeAutoObservable } from 'mobx'
import type ExtendedMap from 'src/models/ExtendedMap'

import type { Notification } from './Notification'

export class NotificationColl<T extends Notification> {
  constructor(private notificationMap: ExtendedMap<T['sortKey'], T>) {
    makeAutoObservable(this)
  }

  get entries() {
    return this.notificationMap.entries()
  }
  get size() {
    return this.notificationMap.size
  }
  get toArr() {
    return this.notificationMap.toArr
  }
  get lastNotification() {
    return this.notificationMap.toArr.reduce((pre, cur) => (pre.sortKey < cur.sortKey ? pre : cur))
  }

  adds(notificationColl: NotificationColl<T>) {
    this.notificationMap.adds(notificationColl.notificationMap.entries())
  }
  addsByArr(notifications: Notification[]) {
    this.notificationMap.addFromArr(notifications, 'sortKey')
  }
  readAll() {
    this.notificationMap.toArr.forEach(({ read }) => read())
  }
  findBySortKey(_sortKey: T['sortKey']) {
    return this.toArr.find(({ sortKey }) => sortKey === _sortKey)
  }
  deleteBySortKey(sortKey: T['sortKey']) {
    this.notificationMap.delete(sortKey)
  }
}
